import * as dot from 'dot-wild';
import * as Highcharts from 'highcharts';
import * as jQuery from 'jquery';
import * as moment from 'moment';
import * as _ from 'underscore';

import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';

import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { R10FilterService } from '../../../shared/filters/filter-r10.service';
import { BaseWidgetComponent } from '../base-widget/base-widget.component';

@Component({
	selector: 'app-product-overview-r10',
	styleUrls: ['./product-overview-r10.component.css'],
	templateUrl: './product-overview-r10.component.html'
})
export class ProductOverviewR10Component extends BaseWidgetComponent implements OnInit {
	public showLoader: boolean;
	public daysButton: boolean = true;
	public weeksButton: boolean = false;
	public monthsButton: boolean = false;
	public seriesData: any;
	public categories: any;
	public disabledColor: string = '#d8d8d8';
	public applyNodata: boolean = false;
	public daysData = [];
	public weeksData = [];
	public monthsData = [];
	public defaultCount: number = 35;
	public defaultCountForWeeks: number = 25;
	public defaultStepCount: number = 6;
	public baseConfig: any;
	public chartConfig: any;
	public chartData: any;
	public emptyChartData: any;

	@Input() uikitresponseconfig: any;
	@Input() customchartconfiguration: any;
	@Input() legend: any;
	@Input() colorsconfig: any;
	@Input() key: string;
	@ViewChild('chartElement', { static: true }) chartElement: ElementRef;
	public isR13 = false;
	constructor(
		protected analyticsService: AnalyticsService,
		protected colorUtilityService: ColorUtilityService,
		protected analyticsDataModel: AnalyticsDataModel,
		protected r10FilterService: R10FilterService
	) {
		super(analyticsService);
	}

	ngOnInit(): void {
		this.isR13 =
			this.analyticsDataModel.config.directoryName === 'lee-r13' ||
			this.analyticsDataModel.config.directoryName === 'default-r13'
				? true
				: false;
		this.uikitresponseconfig = this.uikitresponseconfig ? JSON.parse(decodeURI(this.uikitresponseconfig)) : [];
		this.customchartconfiguration = this.customchartconfiguration
			? JSON.parse(decodeURI(this.customchartconfiguration))
			: {};
		this.customchartconfiguration = this.r10FilterService.evaluateJsonValuesUsingStringPath(
			this.customchartconfiguration
		);
		this.colorsconfig = this.colorsconfig ? JSON.parse(decodeURI(this.colorsconfig)) : [];
		this.baseConfig = {
			chartConfig: this.customchartconfiguration.chartConfig
		};
		if (this.legend) {
			this.legend = JSON.parse(decodeURI(this.legend));
			// sort legend depending on order
			this.legend = _.sortBy(this.legend, 'order');
			// enable disable legend based on permissions
			for (const legendObj of this.legend) {
				if (!this.isR13) {
					if (this.analyticsDataModel.setupData.userPermissions[legendObj.permission.flags[0]]) {
						legendObj.enabled = true;
						this.uikitresponseconfig.push({
							dataType: 'number',
							formatter: '0',
							key: legendObj.value
						});
					} else {
						legendObj.enabled = false;
					}
				} else if (this.isR13) {
					if (this.analyticsDataModel.checkComponentForPermission(legendObj)) {
						legendObj.enabled = true;
						this.uikitresponseconfig.push({
							dataType: 'number',
							formatter: '0',
							key: legendObj.value
						});
					} else {
						legendObj.enabled = false;
					}
				}
			}
		}
		super.ngOnInit();
	}

	requestData(): void {
		this.daysButton = true;
		this.weeksButton = false;
		this.monthsButton = false;
		this.showLoad = true;
		this.hasData = false;
		this.analyticsService.processProductsRequest(this.key).subscribe((response: any) => {
			this.showLoad = false;
			if (response.success) {
				this.hasData = true;
				this.responseData = response.data;
				this.daysData = this.responseData.days;
				this.weeksData = this.responseData.weeks;
				this.monthsData = this.responseData.months;
				this.chartData = this.daysData;
				this.processResponseData(this.daysData);
			} else {
				this.hasData = false;
				this.daysData = [];
				this.weeksData = [];
				this.monthsData = [];
				this.processResponseData([]);
			}
		});
	}

	processResponseData(data: any[]): void {
		this.seriesData = [];
		this.categories = [];
		this.emptyChartData = [];
		this.applyNodata = !data || !data.length ? true : false;
		let noDataCount = 0;
		for (const legendObj of this.legend) {
			let chartSeriesData = _.pluck(data, legendObj.value).filter((val) => val !== undefined);
			// get all null and 0 values for each series
			const checkZeroData = chartSeriesData.filter((val) => val === '0' || val === null);
			// send empty array if all values are 0
			if (checkZeroData.length === chartSeriesData.length) {
				chartSeriesData = [];
				noDataCount++;
			}
			let fillColor = '#ffffff';
			if (data && data.length === 1) {
				fillColor = legendObj.lineType.includes('Dash')
					? '#ffffff'
					: this.colorUtilityService.getHEXByColorType(
							this.analyticsDataModel.partner.colorPalette,
							this.colorsconfig[legendObj.order - 1].color,
							1
					  );
			}
			const seriesColor =
				!data || !data.length || !chartSeriesData.length
					? this.disabledColor
					: this.colorUtilityService.getHEXByColorType(
							this.analyticsDataModel.partner.colorPalette,
							this.colorsconfig[legendObj.order - 1].color,
							1
					  );
			const series = {
				allowZeroData: true,
				axisDataSource: [
					{
						dataType: 'number',
						displayName: legendObj.displayName,
						plotXValueFrom: 'date',
						readFrom: legendObj.value,
						showInSeries: true
					}
				],
				color: seriesColor,
				dashStyle: legendObj.lineType,
				data: [],
				enableMouseTracking: !data || !data.length || !chartSeriesData.length ? false : true,
				events: {
					// tslint:disable-next-line: object-literal-shorthand only-arrow-functions
					legendItemClick: function (): any {
						if (!data || !data.length || !chartSeriesData.length) {
							return false;
						}
						setTimeout(() => {
							this.chart.legend.allItems.forEach((legend, index) => {
								if (!legend.visible && legend.userOptions.dashStyle.includes('Dash')) {
									jQuery(`.highcharts-series-${index}.highcharts-legend-item-hidden path`).attr('fill', '#ffffff');
								}
							});
						}, 100);
					}
				},
				marker: {
					enabled: data.length === 1 ? true : false,
					fillColor: !data || !data.length || !chartSeriesData.length ? this.disabledColor : fillColor,
					lineColor: seriesColor,
					lineWidth: 2,
					radius: data.length === 1 ? 4 : 2,
					symbol: 'circle'
				},
				name: legendObj.displayName,
				type: 'spline'
			};
			if (data.length === 1) {
				this.baseConfig.chartConfig.legend.symbolWidth = 10;
				this.baseConfig.chartConfig.legend.symbolHeight = 10;
			}
			if (legendObj.enabled) {
				this.seriesData.push(series);
			}
		}
		// update applyNodata flag to true to display min max for x and y axis in case if we don't have data
		if (noDataCount === this.legend.length) {
			this.applyNodata = true;
		} else {
			this.applyNodata = false;
		}
		this.drawGraph(data);
	}

	getDatesArray(startDate: string, endDate: string): any[] {
		const dates = [];
		const currDate = moment(startDate).startOf('day');
		const lastDate = moment(endDate).startOf('day');
		const formattedStartDate = moment(startDate).format('YYYY-MM-DD');
		const formattedEndDate = moment(endDate).format('YYYY-MM-DD');
		if (moment(formattedStartDate).isSame(formattedEndDate)) {
			this.emptyChartData.push({
				date: moment(currDate.clone().toDate()).format('YYYY-MM-DD')
			});
			return [moment(currDate.clone().toDate()).format('YYYY-MM-DD')];
		}

		while (currDate.diff(lastDate) < 0) {
			this.emptyChartData.push({
				date: moment(currDate.clone().toDate()).format('YYYY-MM-DD')
			});
			dates.push(moment(currDate.clone().toDate()).format('YYYY-MM-DD'));
			currDate.add(1, 'days');
		}
		return dates;
	}

	updateChartData(type: string): void {
		switch (type) {
			case 'days':
				this.updateButtonStatus('daysButton', ['weeksButton', 'monthsButton']);
				this.processResponseData(this.daysData);
				break;
			case 'weeks':
				this.updateButtonStatus('weeksButton', ['daysButton', 'monthsButton']);
				this.processResponseData(this.weeksData);
				break;
			case 'months':
				this.updateButtonStatus('monthsButton', ['weeksButton', 'daysButton']);
				this.processResponseData(this.monthsData);
				break;
			default:
				this.updateButtonStatus('daysButton', ['weeksButton', 'monthsButton']);
				this.processResponseData(this.daysData);
		}
	}

	updateButtonStatus(enabledType: string, disabledTypes: string[]): void {
		this[`${enabledType}`] = true;
		this[`${disabledTypes[0]}`] = false;
		this[`${disabledTypes[1]}`] = false;
	}

	drawGraph(graphData: any[]): void {
		// tslint:disable-next-line: no-this-assignment
		const self = this;
		this.resetMinMax();
		this.categories = _.pluck(graphData, 'date');
		this.chartData = graphData;
		// generate default data to display if there is no data for selected date range
		if (!graphData || !graphData.length) {
			this.categories = this.getDatesArray(this.analyticsDataModel.startDate, this.analyticsDataModel.endDate);
			this.chartData = this.emptyChartData;
			this.setNoDataMinMax();
		}
		this.baseConfig.chartConfig.series = this.seriesData;
		this.baseConfig.chartConfig.toolTip.formatter = this.getToolTipFormatter();
		this.baseConfig.chartConfig.xAxis[0].labels.formatter = this.getXaxisLabelFormatter();
		this.baseConfig.chartConfig.xAxis[0].categories = this.categories;
		this.baseConfig.chartConfig.xAxis[0].labels.step = this.calculateStepCountByData(graphData) || 5;
		this.chartConfig = {
			chartConfig: this.baseConfig.chartConfig,
			responseConfig: this.uikitresponseconfig
		};
	}

	resetMinMax(): void {
		this.baseConfig.chartConfig.xAxis[0].max = null;
		this.baseConfig.chartConfig.xAxis[0].min = null;
		this.baseConfig.chartConfig.yAxis[0].max = null;
		this.baseConfig.chartConfig.yAxis[0].min = null;
	}

	setNoDataMinMax(): void {
		this.baseConfig.chartConfig.xAxis[0].max = this.categories.length - 1;
		this.baseConfig.chartConfig.xAxis[0].min = 0;
		this.baseConfig.chartConfig.yAxis[0].max = 9000;
		this.baseConfig.chartConfig.yAxis[0].min = 0;
	}

	getToolTipFormatter(): any {
		// tslint:disable-next-line: no-this-assignment
		const self = this;
		return function (): string {
			let dateString = `${moment(self.categories[this.point.index]).format('MMM').substr(0, 3).toLowerCase()} ${moment(
				self.categories[this.point.index]
			).format('D')}, ${moment(self.categories[this.point.index]).format('YYYY')}`;
			if (self.monthsButton) {
				dateString = `${moment(self.categories[this.point.index]).format('MMM').substr(0, 3).toLowerCase()}, ${moment(
					self.categories[this.point.index]
				).format('YYYY')}`;
			}
			return `<div style='width: 11.5rem; padding: 3px'>
				<div style='width: 100%'>
					<div style='width: 50%; display:inline-block'>${this.series.name}</div>
					<div style='width: 50%; display:inline-block; text-align: right'>${dateString}</div>
				</div>
				<div style='width: 100%; color: ${this.color}'>
					<div style='width: 50%; display:inline-block'>impressions</div>
					<div style='width: 50%; display:inline-block; text-align: right'>${Highcharts.numberFormat(this.y, 0, '', ',')}</div>
				</div>
			</div>`;
		};
	}

	getXaxisLabelFormatter(): any {
		// tslint:disable-next-line: no-this-assignment
		const self = this;
		return function (): string {
			let labelString = `${moment(this.value).format('MMM').substr(0, 3).toLowerCase()}<br/>${moment(this.value).format(
				'D'
			)}`;
			if (self.monthsButton) {
				labelString = `${moment(this.value).format('MMM').substr(0, 3).toLowerCase()}`;
			}
			return labelString;
		};
	}

	calculateStepCountByData(data: any[]): number {
		const dataLength = data.length;
		if (!data || !data.length) {
			if (this.categories.length <= this.defaultCount) {
				return 2;
			}
			return Math.ceil(this.categories.length / (this.defaultStepCount * 3));
		} else if (dataLength < 8) {
			return 1;
		} else if (this.daysButton) {
			if (dataLength <= this.defaultCount) {
				return 2;
			}
			return Math.ceil(dataLength / (this.defaultStepCount * 3));
		} else if (!this.daysButton) {
			if (dataLength <= this.defaultCountForWeeks) {
				return 1;
			}
			return Math.ceil(dataLength / (this.defaultStepCount * 3));
		}
	}
}
